import { Component } from '@angular/core';

interface MenuItem {
  step: number;
  label: string;
  icon: string;
  route: string;
  disabled?: boolean;
}

@Component({
  selector: 'app-reposicion-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class ReposicionMenuComponent {
  menuItems: MenuItem[] = [
    {
      step: 1,
      label: 'Selección de sucursal',
      icon: 'pi pi-building',
      route: 'dashboard'
    },
    {
      step: 2,
      label: 'Reposición Asistida',
      icon: 'pi pi-box',
      route: 'asistida'
    }
  ];
}
